import { useParams, Navigate } from "react-router";
import type { DayOfWeek } from "@/types/meal-plan-state";
import { DayPanel } from "@/components/meal-plan/day-panel";
import { useWeekPlan } from "@/context/week-plan-context";
import { getCurrentWeekId, getTodayDayOfWeek } from "@/lib/week-utils";

const VALID_DAYS = new Set<string>(["mon", "tue", "wed", "thu", "fri", "sat", "sun"]);

export function DayPage() {
  const { day } = useParams<{ day: string }>();
  const { basePath } = useWeekPlan();

  if (!day || !VALID_DAYS.has(day)) {
    const weekId = getCurrentWeekId();
    const today = getTodayDayOfWeek(weekId) ?? "mon";
    return <Navigate to={`${basePath}/${weekId}/${today}`} replace />;
  }

  return <DayPanel day={day as DayOfWeek} />;
}
